<template>
  <div class="junhe-rule">
    <img class="logo-img" src="/static/images/junhe/logo.png" alt="logo">

    <div class="rule-card">
      <img class="warning-icon" src="/static/images/junhe/warning.png" alt="warning">
      <div class="rule-title">规则说明</div>
      <div class="rule-content" v-html="activityRule"></div>
    </div>

    <div class="bottom-links">
      <span class="link-text" @click="reScan">继续扫码</span>
    </div>
  </div>
</template>

<script>
import { getTemplate, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'JunHeRule',
  data() {
    return {
      deptId: '',
      appId: process.env.ENV_NUM === '1' ? 'wx2fd80b8155ff35c2' : 'wxbc22565b3e7a59fd',
      activityRule: '',
    }
  },
  mounted() {
    this.getWxJs()
    this.deptId = this.$route.query.deptId || ''
    if (this.deptId) {
      this.getTemplate()
    }
  },
  methods: {
    reScan() {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
      });

    },
    async getTemplate() {
      try {
        const res = await getTemplate(this.deptId)
        if (res.data.code === "200" && res.data.data != null) {
          console.log('Rule页面获取活动模板成功:', res.data.data)
          if (res.data.data.activityRule) {
            this.activityRule = res.data.data.activityRule
          }
        } else {
          console.log('Rule页面暂无可参与的活动')
        }
      } catch (error) {
        console.error('Rule页面获取模板失败:', error)
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openEnterpriseChat',
            'openCustomerService'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
        wx.error(function (res) {
          console.error('Rule页面JSSDK error:', res)
        });
      })
    }
  }
}
</script>

<style scoped>
.junhe-rule {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background: url("/static/images/junhe/bg.png") no-repeat center top;
  background-size: cover;
}

.logo-img {
  position: absolute;
  top: 3vh;
  right: 8vw;
  width: 20vw;
  height: auto;
}

.bottom-links {
  position: fixed;
  bottom: 4vh;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.link-text {
  color: white;
  font-size: 4vw;
  cursor: pointer;
}


.rule-card {
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translateX(-50%);
  width: 85vw;
  height: 35vh;
  background: linear-gradient(135deg, rgba(0, 16, 214, 0.8) 0%, rgba(0, 16, 214, 0.5) 10%, transparent 40%), radial-gradient(circle at 100% 100%, rgba(0, 16, 214, 0.8) 0%, rgba(0, 16, 214, 0.3) 10%, transparent 20%);
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  position: relative;
}

/* 渐变边框效果 */
.rule-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 25px;
  padding: 1px;
  background: linear-gradient(to right, white, gray);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.warning-icon {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 18vw;
  height: auto;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.rule-title {
  color: white;
  font-size: 5vw;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
}

.rule-content {
  width: 100%;
  color: white;
  font-size: 3.5vw;
  line-height: 1.2;
}

.rule-item {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/JunHe/Rule.vue